import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import get from 'transmute/get';
import { TICKET } from 'customer-data-objects/constants/ObjectTypes';
import TicketCreatorPrompt from './TicketCreatorPrompt';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import DisassociateModal from './DisassociateModal';
import { CREATE_TICKET_PROMPT, DISASSOCIATE_PROMPT } from '../constants/PromptTypes';
import { createTicketFailed, createTicketSuccess } from '../actions/createTicketAlert';
import { getCreatedCrmObject } from '../constants/Events';
import { disassociateContact } from '../actions/disassociateContact';
import { getFormattedContactName } from '../../contacts/operators/contactGetters';
import { DISASSOCIATE_CONTACT_MARKER } from '../../performance-metrics/constants/performanceConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactSidebarPrompts = ({
  closePrompt,
  contact,
  openCreateTicketModal,
  promptStatus,
  threadId
}) => {
  const dispatch = useDispatch();
  const handleReject = useCallback(() => {
    closePrompt(CREATE_TICKET_PROMPT);
  }, [closePrompt]);
  const handleTicketCreate = useCallback(({
    error,
    addAnother
  }) => {
    if (error) {
      dispatch(createTicketFailed());
      return;
    }
    trackEvent(getCreatedCrmObject({
      objectType: TICKET
    }));
    dispatch(createTicketSuccess());
    closePrompt(CREATE_TICKET_PROMPT);
    if (addAnother) {
      setTimeout(openCreateTicketModal);
    }
  }, [closePrompt, dispatch, openCreateTicketModal]);
  const handleClose = useCallback(({
    createdObject,
    addAnother,
    error
  }) => {
    if (createdObject || error) {
      handleTicketCreate({
        error,
        addAnother
      });
    }
    handleReject();
  }, [handleReject, handleTicketCreate]);
  const handleSaveDisassociate = useCallback(() => {
    performance.mark(`${DISASSOCIATE_CONTACT_MARKER}-start`);
    dispatch(disassociateContact({
      contactName: getFormattedContactName(contact),
      threadId
    }));
    closePrompt(DISASSOCIATE_PROMPT);
  }, [closePrompt, contact, dispatch, threadId]);
  const shouldRenderTicketPrompt = get(CREATE_TICKET_PROMPT, promptStatus);
  if (shouldRenderTicketPrompt) {
    return /*#__PURE__*/_jsx(TicketCreatorPrompt, {
      contact: contact,
      onClose: handleClose,
      threadId: threadId
    });
  }
  const shouldRenderDisassociatePrompt = get(DISASSOCIATE_PROMPT, promptStatus);
  if (shouldRenderDisassociatePrompt) {
    return (
      /*#__PURE__*/
      // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'DisassociateModal' does not have... Remove this comment to see the full error message
      _jsx(DisassociateModal, {
        contact: contact,
        onConfirm: handleSaveDisassociate,
        onReject: () => closePrompt(DISASSOCIATE_PROMPT)
      })
    );
  }
  return null;
};
ContactSidebarPrompts.displayName = 'ContactSidebarPrompts';
export default ContactSidebarPrompts;